"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencies = exports.chainId = void 0;
const celo_1 = require("../../../erc20/chains/celo");
exports.chainId = 42220;
exports.currencies = Object.assign({}, celo_1.supportedCeloERC20);
